module.exports = __webpack_public_path__ + "img/lucky_family_brand_logo.8f799273.svg";